import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

export const navbarToggleIcon = (
  <FuseSvgIcon size={20} color="action">
    heroicons-outline:view-list
  </FuseSvgIcon>
);

export const notificationToggleIcon = <FuseSvgIcon>heroicons-outline:bell</FuseSvgIcon>;
